export const useIsInProduction = (): boolean => {
  const location: string = window?.location?.href;
  return location && !location.includes('loc.styleseat') && !location.includes('styleseat.rocks') && !location.includes('stage.styleseat');
};
